<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.ApplicationNumber')" prop="applyNo">
                  <!--申请编号-->
                  <el-input v-model.trim="queryCondition.applyNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.supplierName')" prop="supplierName">
                  <!--供应商名称-->
                  <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="supplierCode">
                  <!--供应商编码/邀请码-->
                  <el-input v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('common.status')" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TM_LAW_FILE" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="beginDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.beginDate" type="date" :picker-options="pickerOptionsStart" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="endDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.endDate" type="date" :picker-options="pickerOptionsEnd" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button v-if="isShowFunc" size="mini" class="btn" type="primary" @click="selectType()" v-acl="SaveLawFile">{{$t('common.newBuilt')}}</el-button>
      <el-button v-if="isShowFunc" size="mini" class="btn" type="danger" @click="deleteRow()" v-acl="DeleteLawFile">{{$t('common.del')}}</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" row-key="tmLawFileId" border highlight-current-row max-height='420'>
      <el-table-column fixed sortable type="selection" width="55" align="center" :selectable="(row)=>row.status == '草稿'" :reserve-selection="true"></el-table-column>
      <el-table-column show-overflow-tooltip prop="applyNo" :label="$t('settlementUnit.ApplicationNumber')">
        <template slot-scope="scope">
          <div class="a-link" @click="selectType(scope.row.tmLawFileId)">{{scope.row.applyNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('settlementUnit.suppliercodeOrInvitationCode')" width="140"></el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('settlementUnit.groupShortName')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="formType" :label="$t('settlementUnit.fileType')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="status" :label="$t('settlementUnit.status')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('settlementUnit.riqi')"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "../../../api/settlementUnit/lega-file";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      isShowFunc: true,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        supplierName: null,
        supplierCode: null,
        status: null,
        beginDate: null,
        endDate: null,
      },
      tableList: [],
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.beginDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.queryData(1);
  },
  mounted() {
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    console.log('groupableSupplier', groupableSupplier);
    if (groupableSupplier !== 'false') {
      if (dataScope) {
        if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
          this.isShowFunc = false
        } else {
          this.isShowFunc = true
        }
      }
    }
    console.log('isShowFunc', this.isShowFunc);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.search(this.queryCondition).then(res => {
        this.tableList = res.data.records;
        this.totalCount = res.data.total;
      });
    },

    //新建先选择文件类型
    selectType(id) {
      this.$router.push({
        path: `/LegalFileDetail`,
        query: { id: id }
      });
    },
    async deleteRow() {
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        this.$message({
          message: this.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        if (await this.callConfirm()) {
          let ids = rows.map(data => data.tmLawFileId)
          apiService.deleteById(ids).then((res) => {
            if (res.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }
      }
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        supplierName: null,
        supplierCode: null,
        status: null,
        beginDate: null,
        endDate: null,
      }
      this.queryData();
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
</style>
